import { useFlags } from "launchdarkly-react-client-sdk"

/**
 * Centralized hook for feature flags to allow easy toggling during development.
 */
export const useShowAlertCuration = () => {
  const { showAlertCuration } = useFlags()

  return !!showAlertCuration
}

export const useShowPrecomputedBiothreatSignals = () => {
  const { showPrecomputedBiothreatSignals } = useFlags()

  return !!showPrecomputedBiothreatSignals
}
